// Multipart file-upload API instance.
// Uses 'multipart/form-data' content type; the refresh call inside
// createApiInstance automatically falls back to JSON for the token endpoint.
import { createApiInstance } from './Createapiinstance';
 
export default createApiInstance('multipart/form-data');